import { Button } from '@/components/ui/button';
import {
  Sheet,
  SheetBody,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { EyebrowLabel } from '@/shared/components/EyebrowLabel';

import { useForgeApps } from '../hooks/useForgeApps';
import {
  FORGE_APPS_COPY,
  POLICY_RAIL_COPY as WORDS,
} from '../linkedAccountsCopy';
import { ForgeAppsSection } from './ForgeAppsSection';

/**
 * Sign-in setup, in the rail (spec 165 US3): how many hosts have it, and a
 * sheet to manage it. It is set up once per host, so it no longer takes a
 * section of the page. `openHost` is the sheet's state, kept by the page so
 * "Set up" in Needs a look can open it at a host's form.
 */
export function SignInCard({
  openHost,
  onOpen,
  onClose,
}: {
  /** `undefined`: closed; `null`: open on the list; a host: open at its form. */
  openHost: string | null | undefined;
  onOpen: (host: string | null) => void;
  onClose: () => void;
}) {
  const apps = useForgeApps();
  const data = apps.data;
  const configured = data?.items.filter((app) => app.configured).length ?? 0;

  return (
    <section
      aria-labelledby="commit-identity-sign-in"
      className="border-border bg-card flex flex-col gap-2 rounded-md border p-4"
    >
      <h2 id="commit-identity-sign-in">
        <EyebrowLabel>{WORDS.signIn}</EyebrowLabel>
      </h2>
      {data ? (
        <p className="text-muted-foreground text-sm">
          {data.available
            ? WORDS.signInCount(configured, data.items.length)
            : WORDS.signInUnavailable}
        </p>
      ) : null}
      <Button
        variant="outline"
        size="sm"
        className="self-start"
        onClick={() => onOpen(null)}
      >
        {WORDS.manageSignIn}
      </Button>

      <Sheet
        open={openHost !== undefined}
        onOpenChange={(next) => {
          if (!next) onClose();
        }}
      >
        <SheetContent className="sm:max-w-xl">
          <SheetHeader>
            <SheetTitle>{FORGE_APPS_COPY.heading}</SheetTitle>
            <SheetDescription>{FORGE_APPS_COPY.intro}</SheetDescription>
          </SheetHeader>
          <SheetBody>
            {openHost !== undefined ? (
              <ForgeAppsSection initialHost={openHost} inSheet />
            ) : null}
          </SheetBody>
        </SheetContent>
      </Sheet>
    </section>
  );
}
